/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import "./assets/app.css";
import ArchiveDialog from "./components/PublicDialogs/ArchiveDialog";
import MsgDialog from "./components/PublicDialogs/MsgDialog";
import ApiLayout from "./layout/ApiLayout";
import AppRoutes from "./routes/index";
import * as app from "./services/AppService";
import { reload } from "./store/auth";
import Spinner from "./utils/Spinner";
import { MobileMode } from "./components/MobileMode";
import { isNotChromeMobile } from "./core/utils/is";
import { publicRoutes } from "./routes/RouteList";

const ArStyle = React.lazy(() => import("./utils/RtlTheme"));
const EnStyle = React.lazy(() => import("./utils/LtrTheme"));

export default function App() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    // تم فصلهم من اجل تحسين سرعة التحميل
    const userType = useSelector((store: any) => store.loginState?.userType);
    const archiveDialog = useSelector((store: any) => store.archiveDialog);
    const msgDialog = useSelector((store: any) => store.msgDialog);
    const showSpinner = useSelector((store: any) => store.showSpinner);
    const showWaiting = useSelector((store: any) => store.showWaiting);

    const [state, setState] = useState({
        loading: true,
        OnlyAPI: false,
        options: { winStyle: "bestrate", companyName: "" },
    });

    const path = location.pathname;

    // derived values memoized to avoid recalculation on every render
    const currentLang = app.translate("Lang");

    const IsAr = useMemo(() => currentLang === "ar", [currentLang]);
    const lang = useMemo(() => (currentLang === "ar" ? "rtl" : "ltr"), [currentLang]);
    const mode = useMemo(() => app.getCookie("colorMode", window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), []);
    // keep body theme attribute in sync
    useEffect(() => {
        try {
            document.body.setAttribute("data-bs-theme", mode);
        } catch (e) { }
    }, [mode]);

    // redirect after signin based on userType or path changes
    useEffect(() => {
        if (path === "/Signin") {
            if ([0, 1].includes(+userType)) navigate("/UserDashboard");
            else if (+userType === 2) navigate("/AgentDashboard");
        }
        if (+app.options().IsCentralBank === 1)
            app.hideCentralBtns();
    }, [path, userType, navigate]);

    useEffect(() => {
        const currentRoot = "/" + (window.location.pathname.split("/")[1] || "");
        const IsLogout = publicRoutes.map(r => r.path).includes(currentRoot);

        dispatch(
            reload((res: any) => {
                if (!res?.IsLoged && !IsLogout) navigate("/Signin");

                setState({
                    loading: false,
                    OnlyAPI: !!res?.OnlyAPI,
                    options: res?.IsLoged ? res.User?.Options || res.Options : res?.Options || state.options,
                });
            }, IsLogout) as any
        );

        // request notification permission if available
        try {
            if (typeof Notification !== "undefined" && Notification.permission !== "granted") {
                Notification.requestPermission().catch(() => { /* ignore */ });
            }
        } catch (e) { }

        // ensure defaults for cookies
        if (app.getCookie("colorMode", "empty") === "empty")
            app.setCookie("colorMode", "auto", 365);
        if (app.getCookie("language", "empty") === "empty")
            app.setCookie("language", "ar", 365);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (state.loading) return <Spinner Loading />;
    if (state.OnlyAPI) return <ApiLayout />;

    return (
        <>
            {isNotChromeMobile() ? (
                <MobileMode />
            ) : (
                <div className={lang} data-bs-theme={mode} style={{ direction: app.translate("Lang") === "ar" ? "rtl" : "ltr" }}>
                    <title>{state.options.companyName}</title>
                    <React.Suspense fallback={<Spinner Loading />}>
                        {IsAr ? <ArStyle Style={state.options.winStyle} /> : <EnStyle Style={state.options.winStyle} />}
                    </React.Suspense>

                    <Spinner Loading={showSpinner} Waiting={showWaiting} />
                    <MsgDialog {...msgDialog} />
                    <ArchiveDialog {...archiveDialog} />
                    <AppRoutes />
                </div>
            )}
        </>
    );
}